import { REQUESTS } from '../../constants/backend';
import { reload, sendRequest } from './backendCommon';
import {
    SET_LOCALE_REQUEST,
    SET_LOCALE_FAIL,
    SET_USER_SCORE_FAILED,
    SET_USER_SCORES_SUCCESS,
    UPDATE_NICK_NAME_REQUEST,
    UPDATE_NICK_NAME_FAIL,
    UPDATE_NICK_NAME_SUCCESS
} from './actionTypes/user';
import { USER_PROFILE_FETCH_FAIL, USER_PROFILE_FETCH_SUCCESS } from './actionTypes/userProfile';

export const types = {
    SET_USER_SCORES_SUCCESS: '@bg/SET_USER_SCORES',
    SET_USER_SCORES_FAIL: '@bg/SET_USER_SCORES_FAIL',
    USER_PROFILE_FETCH_SUCCESS: '@bg/USER_PROFILE_FETCH_SUCCESS',
    USER_PROFILE_FETCH_FAIL: '@bg/USER_PROFILE_FETCH_FAIL',
    SET_USER_USERNAME_SUCCESS: '@bg/SET_USER_USERNAME_SUCCESS',
    SET_USER_USERNAME_FAIL: '@bg/SET_USER_USERNAME_FAIL',
    SET_USER_LOCALE_FAIL: '@bg/SET_USER_LOCALE_FAIL'
};

type Dispatch = (action: unknown) => unknown;

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function toRecordPayload(value: unknown): Record<string, unknown> {
    return isRecord(value) ? value : {};
}

export const requestProfileScores = (teamID: number) => (dispatch: Dispatch) => {
    const onSuccess = (payload: unknown) => {
        dispatch({
            type: SET_USER_SCORES_SUCCESS,
            payload: toRecordPayload(payload)
        });
    };

    const onError = (error: unknown) => {
        dispatch({
            type: SET_USER_SCORE_FAILED,
            error
        });
    };

    dispatch(
        sendRequest(
            {
                ...REQUESTS.GET_USER_SCORES,
                route: REQUESTS.GET_USER_SCORES.route.replace('{teamID}', `${teamID}`)
            },
            {
                payload: {},
                onSuccess,
                onError
            }
        )
    );
};

export const updateUserLocale = (locale: string) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_LOCALE_REQUEST,
        payload: {
            locale
        }
    });

    const payload = {
        body: { language_code: String(locale) }
    };

    const onSuccess = () => {
        dispatch(
            reload({
                reason: 'SETTINGS_UPDATED'
            })
        );
    };

    const onError = (error: unknown) => {
        dispatch({ type: SET_LOCALE_FAIL, error });
    };

    dispatch(sendRequest(REQUESTS.PATCH_USER_PROFILE, { payload, onSuccess, onError }));
};

export const updateUserUsername = (personalUsername: string) => (dispatch: Dispatch) => {
    dispatch({
        type: UPDATE_NICK_NAME_REQUEST,
        payload: { nickName: personalUsername }
    });

    const payload = {
        body: { personal_username: String(personalUsername) }
    };

    const onSuccess = (data: { personalUsername?: string }) => {
        dispatch({
            type: UPDATE_NICK_NAME_SUCCESS,
            payload: {
                personalUsername: data.personalUsername
            }
        });
    };

    const onError = (error: unknown) => {
        dispatch({ type: UPDATE_NICK_NAME_FAIL, error });
    };

    dispatch(sendRequest(REQUESTS.PATCH_USER_PROFILE, { payload, onSuccess, onError }));
};

export const fetchProfile = () => (dispatch: Dispatch) => {
    const onSuccess = (payload: unknown) => {
        dispatch({
            type: USER_PROFILE_FETCH_SUCCESS,
            payload: { ...toRecordPayload(payload) }
        });
    };

    const onError = (error: unknown) => {
        dispatch({
            type: USER_PROFILE_FETCH_FAIL,
            error
        });
    };

    dispatch(
        sendRequest(REQUESTS.GET_USER_PROFILE, {
            onSuccess,
            onError
        })
    );
};
